import useAuthenticate from "src/hooks/useAuthenticate";
import ProfileButton from "../../components/atoms/profile-button";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import {
  Container,
  Content,
  PageLocationTitle,
  PageTitleContainer,
  ProfileContainer,
  ProfileList,
} from "./styles";
import { useEffect, useState } from "react";
import Loading from "src/components/atoms/loading";
import TournamentPickerModal from "src/components/organisms/tournamentPickerModal";
import api from "src/services/api";
import { Box, CircularProgress, Typography, Switch } from "@mui/material";

const acessos = [
  {
    label: "Torneios",
    url: "/",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
  {
    label: "Minhas Inscrições",
    url: "/profile/subscription",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Atletas",
    url: "/profile/athletes",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/meus-atletas.png",
  },
];

// const outrosAcessos = [
//   {
//     label: "Meus Dados",
//     url: "/profile/edit/user",
//     icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/meu-perfil.png",
//   },
// ];

const acessosAdm = [
  {
    label: "Gerenciar Pagamentos",
    url: "/admin/subscriptions",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
  {
    label: "Gerenciar Torneios",
    url: "/admin/tournament/management",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
  {
    label: "Cadastrar Contas de Banco",
    url: "/tournament/connect-bank",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
  {
    label: "Alterar valor de um campeonato",
    url: "/invalidateUnpayedCheckout",
    icon: "https://ih1.redbubble.net/image.2219051094.1908/raf,360x360,075,t,fafafa:ca443f4786.jpg",
  },
  {
    label: "Gerenciar Usuários",
    url: "/admin/users/management",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/meus-atletas.png",
  },
  {
    label: "Financeiro por Torneio",
    url: "/admin/payment-management",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Atletas por Academia",
    url: "/admin/athletes-per-academy",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/meus-atletas.png",
  },
  {
    label: "Pagamentos Manuais",
    url: "/admin/manual-payments-report",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Não Pagos",
    url: "/admin/unpaid-report",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Dashboard Financeiro",
    url: "/admin/financial-dashboard",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Dívidas Jander",
    url: "/jander",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
  {
    label: "Homologação CHECKOUT",
    url: "/tournament/instrucao-teste-pagbank",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
  {
    label: "Homologação CONNECT",
    url: "/tournament/instrucao-teste-connect",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
];
const myTournamentsList = [
  {
    label: "Gerenciar Pagamentos",
    url: "/tournament/subscriptions",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
  {
    label: "Financeiro por Torneio",
    url: "/tournament/payment-management",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Atletas por Academia",
    url: "/tournament/athletes-per-academy",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/meus-atletas.png",
  },
  {
    label: "Pagamentos Manuais",
    url: "/tournament/manual-payments-report",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Não Pagos",
    url: "/tournament/unpaid-report",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/inscricoes-eventos.png",
  },
  {
    label: "Cadastrar Campeonato",
    url: "/tournament/new",
    icon: "https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png",
  },
];

const ProfileEvent = () => {
  const { account, getToken, loading }: any = useAuthenticate();
  const [myTournaments, setMyTournaments] = useState<any[]>([]); // só do usuário
  const [allTournaments, setAllTournaments] = useState<any[]>([]); // todos (manager)
  //const [loading, setLoading] = useState(true);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pickerMode, setPickerMode] = useState<any>("");
  const isManager = account?.roles?.includes("manager") === true;
  const isTournamentOwner = account?.roles?.includes("tournament_owner") === true;
  const [allowAnonymousOss, setAllowAnonymousOss] = useState(false);
  const [ossConfigLoading, setOssConfigLoading] = useState(false);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);

  const fetchData = async () => {
    try {

      if (account.roles?.includes("manager")) {

        const response = await api.get("/managers/tournaments/info", {
          headers: { Authorization: `Bearer ${getToken()}` },
        });

        const sortedAll = [...response.data].sort((a, b) =>
          a.name.localeCompare(b.name, "pt-BR")
        );
        setAllTournaments(sortedAll);
      }

      if (account.roles?.includes("tournament_owner")) {

        const response = await api.get("/managers/tournaments/info", {
          headers: { Authorization: `Bearer ${getToken()}` },
        });

        const filtered = response.data.filter((r: any) => r.authorId === account?.id);

        const sortedMine = [...filtered].sort((a, b) =>
          a.name.localeCompare(b.name, "pt-BR")
        );
        setMyTournaments(sortedMine);
      }

    } catch (err) {
      console.error(err);
      //  setLoading(false);
    } finally {
      //  setLoading(false);
    }
  };

  useEffect(() => {
    if (!account) return;
    fetchData();
    if (account.roles?.includes("manager")) {
      api.get("/tournaments/oss/config").then(({ data }) => {
        setAllowAnonymousOss(data.allowAnonymous);
      }).catch(() => {});
    }
  }, [account]);

  const toggleAnonymousOss = async () => {
    setOssConfigLoading(true);
    try {
      const { data } = await api.patch("/tournaments/oss/config",
        { allowAnonymous: !allowAnonymousOss },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setAllowAnonymousOss(data.allowAnonymous);
    } catch (err) {
      console.error(err);
    } finally {
      setOssConfigLoading(false);
    }
  };

  return (
    <>

      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',   // centraliza horizontalmente
            alignItems: 'center',       // centraliza verticalmente
            backdropFilter: 'blur(6px)', // 👈 aplica o blur no fundo
            backgroundColor: 'rgba(255, 255, 255, 0.4)', // leve transparência
            zIndex: 2000,               // garante que fica acima de tudo
            gap: 2,
          }}
        >
          <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '1.1rem' }}>
            Aguarde, estamos carregando seus dados...
          </Typography>

          <CircularProgress sx={{ color: 'black' }} />
        </Box>
      )}

      <NavBar />
      <Container>
        <Content>
          <PageTitleContainer>
            <PageLocationTitle>Acessos Rápidos</PageLocationTitle>
          </PageTitleContainer>
          <ProfileContainer>
            <ProfileList>
              {acessos &&
                acessos.map((buttons: any) => (
                  <ProfileButton
                    label={buttons.label}
                    icon={buttons.icon}
                    url={buttons.url}
                    hasError={false}
                    error="Este campo é obrigatório"
                  />
                ))}
            </ProfileList>
          </ProfileContainer>
        </Content>
        {/* <Content>
          <PageTitleContainer>
            <PageLocationTitle>Outros Acessos</PageLocationTitle>
          </PageTitleContainer>
          <ProfileContainer>
            <ProfileList>
              {outrosAcessos &&
                outrosAcessos.map((buttons: any) => (
                  <ProfileButton
                    label={buttons.label}
                    icon={buttons.icon}
                    url={buttons.url}
                    hasError={false}
                    error="Este campo é obrigatório"
                  />
                ))}
            </ProfileList>
          </ProfileContainer>
        </Content> */}

        {isTournamentOwner ? (
          <Content>
            <PageTitleContainer>
              <PageLocationTitle>Acessos Gerenciador</PageLocationTitle>
            </PageTitleContainer>

            <ProfileContainer>
              <ProfileList>
                {myTournamentsList.map((buttons: any) => (
                  <ProfileButton
                    label={buttons.label}
                    icon={buttons.icon}
                    url={buttons.url}
                    hasError={false}
                    error="Este campo é obrigatório"
                  />
                ))}
                {/* CARD NOVO: Selecionar Torneio... */}
                <div
                  onClick={(e) => { e.preventDefault(); setPickerMode("mine"); setPickerOpen(true); }}
                  style={{ cursor: "pointer" }}
                >
                  <ProfileButton
                    label="Chaveamento de torneios"
                    icon="/icons/chaveteste.png"
                    url="#"
                    hasError={false}
                    error="Este campo é obrigatório"
                  />
                </div>
              </ProfileList>
            </ProfileContainer>
          </Content>
        ) : null}

        {isManager ? (
          <Content>
            <PageTitleContainer>
              <PageLocationTitle>Acessos Administrador</PageLocationTitle>
            </PageTitleContainer>

            <ProfileContainer>
              <ProfileList>
                {acessosAdm && isManager &&
                  acessosAdm.map((buttons: any) => (
                    <ProfileButton
                      label={buttons.label}
                      icon={buttons.icon}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório" />
                  ))}
                <div
                  onClick={(e) => { e.preventDefault(); setPickerMode("all"); setPickerOpen(true); }}
                  style={{ cursor: "pointer" }}
                >
                  <ProfileButton
                    label="Chaveamento de torneios"
                    icon="/icons/chaveteste.png"
                    url="#"
                    hasError={false}
                    error="Este campo é obrigatório"
                  />
                </div>
                <div
                  onClick={(e) => { e.preventDefault(); setSettingsModalOpen(true); }}
                  style={{ cursor: "pointer" }}
                >
                  <ProfileButton
                    label="Configurações do Site"
                    icon="https://soucompetidor.com.br/static/v2/css/img/meu-perfil/atleta/minha-equipe.png"
                    url="#"
                    hasError={false}
                    error="Este campo é obrigatório"
                  />
                </div>
              </ProfileList>
            </ProfileContainer>
          </Content>
        ) : (
          null
        )}
      </Container>
      <TournamentPickerModal
        open={pickerOpen}
        myTournaments={pickerMode === "mine" ? myTournaments : allTournaments}
        onClose={() => setPickerOpen(false)}
        getToken={getToken}
      />
      {/* Modal Configurações do Site */}
      {settingsModalOpen && (
        <Box
          onClick={() => setSettingsModalOpen(false)}
          sx={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 3000,
          }}
        >
          <Box
            onClick={(e: any) => e.stopPropagation()}
            sx={{
              background: "#fff",
              borderRadius: "16px",
              padding: "24px",
              maxWidth: "420px",
              width: "90%",
              boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography sx={{ fontWeight: 800, fontSize: "1.1rem", color: "#1A2252", fontFamily: "'Barlow Condensed', sans-serif" }}>
                Configurações do Site
              </Typography>
              <button
                onClick={() => setSettingsModalOpen(false)}
                style={{ background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer", color: "#888" }}
              >
                ✕
              </button>
            </Box>

            <Box sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#f8f9fb",
              borderRadius: "12px",
              padding: "14px 16px",
              border: "1px solid #e5e7eb",
            }}>
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: "0.9rem", color: "#1A2252" }}>
                  👊 OSS Anônimo (usuário não logado)
                </Typography>
                <Typography sx={{ fontSize: "0.72rem", color: "#888", mt: 0.3 }}>
                  {allowAnonymousOss ? "Qualquer pessoa pode dar OSS" : "Apenas usuários logados"}
                </Typography>
              </Box>
              <Switch
                checked={allowAnonymousOss}
                onChange={toggleAnonymousOss}
                disabled={ossConfigLoading}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#1A2252" },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#1A2252" },
                }}
              />
            </Box>
          </Box>
        </Box>
      )}

      <Footer />
    </>
  );
};

export default ProfileEvent;
